import "core-js/modules/es.array.push.js";
import api from "./../../common/api";
import common from "./../../common/common.js";
import qs from 'qs';
import menuLeft from './../components/menuLeft';
import Header from './../components/header';
import Socket from './../components/socket';
import { ElMessageBox, ElNotification } from 'element-plus';
export default {
  name: 'HomeIndex',
  components: {
    menuLeft,
    Header,
    Socket
  },
  data: function () {
    return {
      isUrl: false,
      menuUrl: '',
      socketOpen: false,
      title: '首 页',
      isCollapse: false,
      menuLeftWidth: '',
      menuLeftWidthLong: '160px',
      menuLeftWidthShort: '64px',
      loading: false,
      tipCount: 0,
      tipMaxCount: 3,
      intervalTime: 60 * 2,
      //间隔时间，秒单位
      timer: '',
      mp3: {
        appointmentAuto: api.config().uploadUrl + '/static/mp3/appointmentAuto.mp3',
        checkReport: api.config().uploadUrl + '/static/mp3/checkReport.mp3'
      },
      mp3Url: '',
      emit: 'lineManCount',
      //回调函数名
      update_online_count: 0,
      appointmentAutoMp3Show: false,
      userInfo: {} //当前帐号信息
    };
  },

  computed: {
    routes() {
      return this.$router.options.routes;
    }
  },
  watch: {
    '$route'(to) {
      this.isUrl = to.query.url ? true : false;
      this.menuUrl = to.query.url;
      // 在mounted函数执行的方法，放到该处
      // 加载页面数据的方法
    }
  },

  mounted() {
    var that = this;
    var userInfo = JSON.parse(localStorage.getItem('userInfo'));
    // 在线人数统计
    this.sendData = {
      type: 'zsmyMessage',
      emit: 'lineManCount',
      Authorization: userInfo.token + '^^' + userInfo.member_id
    };
    this.socketOpen = true;
    setTimeout(function () {
      //that.$refs.Socket.websocketSendMessage(that.sendData);
      that.$refs.Socket.isLogin(that.sendData); //开启心跳
    }, 10);
  },
  created: function () {
    document.title = this.title;
    var isCollapse = localStorage.getItem('isCollapse');
    this.isCollapse = isCollapse == 'true' ? true : false;
    this.menuLeftWidth = isCollapse == 'true' ? this.menuLeftWidthShort : this.menuLeftWidthLong;
    this.clientHeight = document.documentElement.clientHeight + 'px';
    if (localStorage.getItem('isLogin')) {
      var userInfo = JSON.parse(localStorage.getItem('userInfo'));
      if (userInfo) {
        this.userInfo = userInfo;
        this.comebackTip(userInfo);
        this.appointmentAutoTip();
        this.audioMp3Tip();
      }
    }
  },
  methods: {
    send: function () {
      this.$refs.Socket.websocketSendMessage({
        msg: '发送一条数据...'
      });
    },
    open: function () {
      this.$refs.Socket.websocketOpen();
    },
    close: function () {
      this.$refs.Socket.websocketClose();
    },
    lineManCount: function (e) {
      this.update_online_count = e.manCount ? e.manCount : 0;
    },
    autoPlay: function () {
      this.appointmentAutoMp3Show = true;
      var that = this;
      setTimeout(function () {
        //that.$refs.Audio.play();
        that.$refs.Audio.play().catch(error => {
          console.error('Error attempting to play:', error);
          // 音频加载成功
          // 音频的播放需要耗时
          setTimeout(() => {
            // 后续操作
            console.log("done.");
          }, that.$refs.Audio.duration * 1000); // audio.duration 为音频的时长单位为秒
        });
      }, 500);
      setTimeout(function () {
        that.closePlay();
      }, 6500);
      // this.timer = setTimeout(function(){
      // 	that.tipCount++;
      // 	that.autoPlay();
      // 	if(that.tipCount>=that.tipMaxCount){
      // 		clearTimeout(that.timer);
      // 	}

      // },that.intervalTime*1000);
    },

    closePlay: function () {
      this.appointmentAutoMp3Show = false;
    },
    newMessage: function (e) {
      var that = this;
      var confirmButtonText = '确 认';
      var emit = e.emit ? e.emit : '';
      var popup = e.popup ? e.popup : '';
      var allowDepartment = e.allowDepartment ? e.allowDepartment : [];
      switch (emit) {
        case 'lineManCount':
          this.update_online_count = e.manCount ? e.manCount : 0;
          break;
        case 'appointmentAutoTip':
          confirmButtonText = '查看自助预约';
          if (allowDepartment && allowDepartment.includes(this.userInfo.department.toString())) {
            this.tipCount = 0;
            this.mp3Url = this.mp3.appointmentAuto;
            this.$refs.playVideo.click(); //自助预约语音提醒
          }

          break;
        case 'smsCallBackTip':
          confirmButtonText = '提醒：预约短信';
          var tipType = 'notification';
          break;
        case 'checkReport':
          //console.log(this.userInfo);
          confirmButtonText = '查看检查报告';
          if (allowDepartment && allowDepartment.includes(this.userInfo.department.toString())) {
            this.tipCount = 0;
            this.mp3Url = this.mp3.checkReport;
            this.$refs.playVideo.click(); //检查报告语音提醒
          }

          break;
        case 'comebackTip':
          confirmButtonText = '跳转至复诊页面';
          break;
        default:
      }
      //console.log('department',allowDepartment.includes(this.userInfo.department.toString()));
      if (popup && e.msg && allowDepartment && allowDepartment.includes(this.userInfo.department.toString())) {
        var customClass = customClass ? customClass : '';
        switch (tipType) {
          case 'notification':
            ElNotification({
              title: '系统消息',
              message: e.msg,
              type: e.success == 1 ? 'success' : 'error'
            });
            break;
          default:
            ElMessageBox.alert(e.msg, '系统消息', {
              cancelButtonText: '关 闭',
              confirmButtonText: confirmButtonText,
              //确定按钮的文本内容
              showCancelButton: true,
              dangerouslyUseHTMLString: true,
              //是否将 message 作为 HTML 片段处理
              autofocus: true,
              //是否自动获得焦点
              draggable: true,
              customClass: customClass,
              callback: function (action) {
                //console.log('e.page',e.page);
                clearTimeout(that.timer);
                if (action == 'confirm') {
                  if (e.page) {
                    that.$router.push(e.page);
                  }
                }
              }
            });
        }
      }
    },
    isLoading: function (e) {
      //console.log('loading-index',e.value);
      this.loading = e.value;
    },
    collapseChange: function () {
      var that = this;
      var menuLeftWidth = this.menuLeftWidthLong;
      var isCollapse = localStorage.getItem('isCollapse');
      isCollapse = isCollapse == 'true' ? false : true;
      this.isCollapse = isCollapse;
      if (isCollapse == true) {
        menuLeftWidth = this.menuLeftWidthShort;
        setTimeout(function () {
          that.menuLeftWidth = menuLeftWidth;
        }, 250);
      } else {
        this.menuLeftWidth = menuLeftWidth;
      }
      localStorage.setItem('isCollapse', isCollapse);
      localStorage.setItem('menuLeftWidth', menuLeftWidth);
    },
    appointmentAutoTip: function () {
      var appointmentAutoTip = localStorage.getItem('appointmentAutoTip');
      //var department = userInfo ? userInfo.department : 0;
      if (appointmentAutoTip == 1) {
        return false;
      }
      var that = this;
      this.loading = true;
      var data = {};
      // 异步更新数据
      this.$post(api.doMain() + '/hospital/appointmentAuto/getCountTip', qs.stringify(qs.parse(data))).then(function (res) {
        setTimeout(function () {
          that.loading = false;
        }, 200);
        localStorage.setItem('appointmentAutoTip', 1);
        if (res.rt == 1 && res.count > 0) {
          that.newMessage({
            emit: 'appointmentAutoTip',
            allowDepartment: ['1', '2'],
            msg: '你有 <font color="red">' + res.count + '</font> 条自助预约提醒',
            popup: 1,
            page: '/hospital/appointmentAuto?tip=1'
          });
        }
      }).catch(function (error) {
        setTimeout(function () {
          that.loading = false;
        }, 200);
        common.networkError(error);
        //vant.Toast.loading({message:'网络不稳，重新加载'});
      });
    },

    audioMp3Tip: function () {
      var audioMp3Tip = localStorage.getItem('audioMp3Tip');
      //var department = userInfo ? userInfo.department : 0;
      if (audioMp3Tip == 1) {
        return false;
      }
      var that = this;
      this.loading = true;
      var data = {};
      // 异步更新数据
      this.$post(api.doMain() + '/hospital/audioLogs/getCountTip', qs.stringify(qs.parse(data))).then(function (res) {
        setTimeout(function () {
          that.loading = false;
        }, 200);
        localStorage.setItem('audioMp3Tip', 1);
        if (res.rt == 1 && res.count == 0) {
          that.newMessage({
            emit: 'audioMp3Tip',
            allowDepartment: ['1', '2'],
            msg: '<style>#audioMp3Tip_animate{color:rgb(196, 86.4, 86.4);-webkit-animation:flash 2s .3s linear infinite;-moz-animation:flash 2s .3s linear infinite;}@-webkit-keyframes flash{0%,50%,100%{opacity: 1;font-size:14px;}25%,75%{opacity: 0;font-size:15px;}}@-moz-keyframes flash{0%,50%,100%{opacity: 1;font-size:12px;}25%,75%{opacity: 0;font-size:14px;}</style><font id="audioMp3Tip_animate">24个小时无录音数据， 请查看录音设备是否正常运行！</font>',
            popup: 1,
            page: '/hospital/audioLogs?tip=1'
          });
        }
      }).catch(function (error) {
        setTimeout(function () {
          that.loading = false;
        }, 200);
        common.networkError(error);
        //vant.Toast.loading({message:'网络不稳，重新加载'});
      });
    },

    comebackTip: function (userInfo) {
      var comebackTip = localStorage.getItem('comebackTip');
      var department = userInfo ? userInfo.department : 0;
      console.log('comebackTip', comebackTip, department);
      if (department != 1 || comebackTip == 1) {
        return false;
      }
      var that = this;
      this.loading = true;
      var data = {};
      // 异步更新数据
      this.$post(api.doMain() + '/hospital/comeback/getComebackTip', qs.stringify(qs.parse(data))).then(function (res) {
        setTimeout(function () {
          that.loading = false;
        }, 200);
        if (res.rt == 1 && res.count > 0 && res.tip == 0) {
          that.newMessage({
            emit: 'comebackTip',
            allowDepartment: ['1'],
            msg: '你有 <font color="red">' + res.count + '</font> 条复诊提醒',
            popup: 1,
            page: '/hospital/comeback?tip=1'
          });
        } else {
          localStorage.setItem('comebackTip', 1);
        }
      }).catch(function (error) {
        setTimeout(function () {
          that.loading = false;
        }, 200);
        common.networkError(error);
        //vant.Toast.loading({message:'网络不稳，重新加载'});
      });
    }
  }
};